module.exports = __webpack_public_path__ + "img/accordion-icon-white.dd2f86cd.svg";